import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";

const ImageDetailsModal = ({ show, onCloseClick, onDetailClick, selectedImage, folderName, onDeleteClick, onClickEdit }: any) => {
  if (!selectedImage) return null;
  console.log(selectedImage)

  const handleDownload = () => {
    window.open(selectedImage.url, "_blank");
  };

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(selectedImage.url)
      .then(() => {
        toast.success("Copy Success", { autoClose: 500 })
      })
      .catch((err) => {
        alert("Failed to copy link!");
      });
  };

  const handleClick = () => {
    onClickEdit();
    onCloseClick();
  };

  return (
    <>
        <ToastContainer closeButton={false} limit={1} />
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="lg" className="position-relative">
      <ModalBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="m-0">Image Details</h5>
          <i
            className="bx bx-x fs-3 cursor-pointer"
            onClick={onCloseClick}
            style={{ color: "#CACACA" }}
            data-testing-Id="closeImageDetail_mediaCenter"
          ></i>
        </div>
        <div className="d-flex gap-4">
          {/* Left Section: Image */}
          <div className="image-container" style={{ flex: "1" }}>
            <img
              src={selectedImage.url}
              className="img-fluid rounded"
              style={{ maxWidth: "100%" }}
            />
          </div>
          {/* Right Section: Details */}
          <div style={{ flex: "1" }}>
            <p className="mb-2"><strong>Name:</strong>{selectedImage?.metaData?.name}</p>
            <p className="mb-2"><strong>Location:</strong> {folderName || "Ungroup Images"}</p>
            <p className="mb-2"><strong>Dimension:</strong> {selectedImage?.metaData?.width} * {selectedImage?.metaData?.height}</p>
            <p className="mb-2"><strong>Size:</strong> 12</p>
            <p className="mb-2"><strong>Time:</strong> {new Date(selectedImage?.createdOn).toLocaleString()}</p>
            <p className="mb-2">
              <strong>Link:</strong>{" "}
              <span className="text-primary cursor-pointer" data-testing-Id="copyLinkImageDetail_mediaCenter" onClick={handleCopyLink}>Copy Link</span>
            </p>
            {/* Operations */}
            <div>
              <strong>Operation:</strong>{" "}
              <span
                  className="text-primary cursor-pointer me-3"
                  // onClick={onClickEdit}
                  onClick={handleClick}
                  data-testing-Id="editImageDetail_mediaCenter"
              >
                Edit
              </span>
              <span
                className="text-danger cursor-pointer me-3"
                onClick={onDeleteClick}
                data-testing-Id="deletImageDetail_mediaCenter"
              >
                Delete
              </span>
              <span className="text-success cursor-pointer" data-testing-Id="downloadImageDetail_mediaCenter" onClick={handleDownload}>Download</span>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
    </>
  );
};

ImageDetailsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onDetailClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  selectedImage: PropTypes.object,
  folderName: PropTypes.string.isRequired,
  onClickEdit: PropTypes.func.isRequired
};

export default ImageDetailsModal;
